angular.module('app').controller('OptionCtrl', function($http, $mdDialog, option, appUtils, $mdToast) {
    "ngInject";

    var main = this;
    main.saving = false;
    main.item = option;
    main.dialog = $mdDialog;

    main.removeChoice = function(choice) {
        var removed = appUtils.remove(choice, 'id', main.item.options.choices);
        if(!main.item.options.deletedOptions) {
            main.item.options.deletedOptions = [];
        }
        main.item.options.deletedOptions.push(removed);
    };

    main.addChoice = function() {
        main.item.options.choices.push({
            'id': new Date().getTime()
        });
    };

    main.save = function() {
        if(main.embedded) {
            $mdDialog.hide(main.item);
            return;
        }

        var method = 'POST';
        var url = '/api/v1/admin/product_option';
        if(main.item.id) {
            method = 'PUT';
            url += '/' + main.item.id;
        }

        main.saving = $http({'method': method, 'url': url, 'data': main.item}).then(
            function(results) {
                main.item.id = results.data.id;
                var message = "Option saved";
                var alert = $mdToast.simple().textContent(message);
                $mdToast.show(alert);
                $mdDialog.hide();
            }
        );
    };
});
